/**
 * Handwritten message add-on.
 *
 * The message textarea submits as a line item property on the card via the
 * product form. This script:
 *  1. toggles the message box open/closed with the checkbox
 *  2. blocks submission if the box is ticked but the message is empty
 *  3. after the card is added (Dawn's cartUpdate event), adds the paid
 *     "Handwritten Message" service product and re-renders the cart drawer
 */
(() => {
  // Quick-add modals re-execute injected scripts; never initialize twice.
  if (window.__hwMessageInit) return;
  window.__hwMessageInit = true;

  function initWrap(wrap) {
    const toggle = wrap.querySelector('[data-hw-toggle]');
    const body = wrap.querySelector('[data-hw-body]');
    const text = wrap.querySelector('[data-hw-text]');
    const count = wrap.querySelector('[data-hw-count]');
    const error = wrap.querySelector('[data-hw-error]');

    // Ancestors animated by Dawn's scroll reveal carry a transform, which
    // re-anchors position:fixed — hoist the example modal to <body>.
    const exampleModal = wrap.querySelector('modal-dialog');
    if (exampleModal) document.body.appendChild(exampleModal);

    toggle.addEventListener('change', () => {
      body.hidden = !toggle.checked;
      text.disabled = !toggle.checked;
      if (toggle.checked) {
        text.focus();
      } else {
        error.hidden = true;
      }
    });

    text.addEventListener('input', () => {
      count.textContent = `${text.value.length}/${text.maxLength}`;
      if (text.value.trim()) error.hidden = true;
    });
  }

  document.querySelectorAll('[data-hw-wrap]').forEach(initWrap);

  // Validate before Dawn's product form handler runs (capture phase).
  document.addEventListener(
    'click',
    (evt) => {
      const button = evt.target.closest('.product-form__submit');
      if (!button) return;
      const form = button.closest('form');
      const wrap = form && form.querySelector('[data-hw-wrap]');
      if (!wrap) return;
      const toggle = wrap.querySelector('[data-hw-toggle]');
      const text = wrap.querySelector('[data-hw-text]');
      if (toggle.checked && !text.value.trim()) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        wrap.querySelector('[data-hw-error]').hidden = false;
        text.focus();
      }
    },
    true
  );

  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event || event.source !== 'product-form') return;

    // Find the form this add came from: its variant id matches the event.
    const wrap = [...document.querySelectorAll('[data-hw-wrap]')].find((el) => {
      const form = el.closest('form');
      const toggle = el.querySelector('[data-hw-toggle]');
      return (
        form &&
        toggle.checked &&
        form.querySelector('[name=id]') &&
        form.querySelector('[name=id]').value === String(event.productVariantId)
      );
    });
    if (!wrap) return;

    const form = wrap.closest('form');
    const text = wrap.querySelector('[data-hw-text]');
    const qtyInput =
      form.querySelector('[name=quantity]') || document.querySelector(`[name=quantity][form="${form.id}"]`);
    const quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const payload = {
      items: [
        {
          id: parseInt(wrap.dataset.hwVariantId, 10),
          quantity: quantity,
          properties: {
            For: wrap.dataset.hwProductTitle,
            Message: text.value.trim(),
          },
        },
      ],
    };
    if (cart) {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
    }

    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('Handwritten message add-on failed to add:', response);
          return;
        }
        if (cart) cart.renderContents(response);
        // Reset for the next add so the fee is a deliberate choice each time.
        const toggle = wrap.querySelector('[data-hw-toggle]');
        toggle.checked = false;
        toggle.dispatchEvent(new Event('change'));
        text.value = '';
      })
      .catch((e) => console.error('Handwritten message add-on error:', e));
  });
})();
